import { isShareCredentials, LiveSessionError } from './share.js';

export const MAX_TEXT_LENGTH = 2000;
export const textMessageErrorKey = error => {
  if (['expired', 'revoked', 'invalid', 'session-gone', 'session-ended'].includes(error?.code)) return 'voice.sessionEnded';
  if (error?.code === 'rate-limited') return 'voice.tryLater';
  if (error?.code === 'too-long' || error?.code === 'too-large') return 'text.tooLong';
  return 'text.sendFailed';
};
export const sendTextMessage = async ({ credentials, messageId, text, senderName = '', signal, fetchImpl = globalThis.fetch }) => {
  if (!isShareCredentials(credentials)) throw new LiveSessionError('invalid', 'Invalid session link.');
  if (typeof text !== 'string' || !text.trim()) throw new LiveSessionError('empty-message', 'Enter a message.');
  if (text.length > MAX_TEXT_LENGTH) throw new LiveSessionError('too-long', 'Message is too long.');
  let response;
  try {
    response = await fetchImpl('/api/live-message', {
      method: 'POST', headers: { 'Content-Type': 'application/json' }, cache: 'no-store', referrerPolicy: 'no-referrer', signal,
      body: JSON.stringify({ ...credentials, messageId, text: text.trim(), senderName: senderName.trim() })
    });
  } catch { throw new LiveSessionError('network', 'The message could not be sent.'); }
  const data = await response.json().catch(() => ({}));
  if (!response.ok || data.ok !== true) throw new LiveSessionError(data.error || 'network', data.message || 'The message could not be sent.', response.status);
  return data;
};
